import React, { useCallback } from 'react';
import './userFileUploader.module.scss';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { NativeTypes } from 'react-dnd-html5-backend';
import classNames from 'classnames';
import { useDrop } from 'react-dnd';

type Props = {
    id?: string;
    onUploadRequest: (files: File[]) => any;
};
export const UserFileUploader = ({ id, onUploadRequest }: Props) => {
    const hiddenFileInput = React.useRef(null);
    const handleManualUploadRequest = useCallback(
        () => {
            hiddenFileInput.current.click();
        },
        [hiddenFileInput]
    );
    const handleManualFileChange = useCallback((e) => {
        onUploadRequest([...e.target.files]);
    }, []);
    const onDrop = useCallback((monitor) => {
        onUploadRequest(monitor.getItem().files);
    }, []);
    const [{ canDrop, isOver }, drop] = useDrop({
        accept: [NativeTypes.FILE],
        drop(item, monitor) {
            onDrop(monitor);
        },
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
    });
    return (
        <div
            ref={drop}
            className="user-file-uploader"
            styleName={classNames('user-file-uploader', { dragging: canDrop, droppable: canDrop && isOver })}
        >
            <div styleName="text">
                {isOver && canDrop ? 'ドロップするとアップロードを開始します' : 'アップロードするファイルをドロップ'}
            </div>
            <div styleName="or">または</div>
            <Button
                type="primary"
                onClick={handleManualUploadRequest}
                styleName="manual-upload-button"
                className="manual-upload-button"
            >
                ファイルを選択
            </Button>
            <input
                id={id}
                type="file"
                ref={hiddenFileInput}
                onChange={handleManualFileChange}
                multiple={true}
                style={{ display: 'none' }}
            />
        </div>
    );
};
